export default function NotFound() {
  return (
    <div>
      <h2>404, Page Not Found!</h2>
    </div>
  );
}
